import { IAqxTraderThemeColors } from '@aquariuxfintech/aqx-trader-sdk-config/theme';

/** For current theme mode, system scheme will be set to either dark or light based on the system setting */
export enum EAppThemeMode {
  DARK = 'DARK',
  LIGHT = 'LIGHT'
}

/** For Appearance dropdown options*/
export enum EAppThemeScheme {
  DARK_SCHEME = 'DARK_SCHEME',
  LIGHT_SCHEME = 'LIGHT_SCHEME',
  SYSTEM_SCHEME = 'SYSTEM_SCHEME'
}
export interface IAppThemeColors extends IAqxTraderThemeColors {}

export interface IAppTheme {
  themeMode: EAppThemeMode;
  themeColors: IAppThemeColors;
  fontFamily: string | undefined;
}

export interface ITenantColors {
  primary: string;
  positive: string;
  negative: string;
}
